// @generated by protoc-gen-es v1.9.0 with parameter "target=ts"
// @generated from file no/jotta/openapi/auth/v2/auth.v2.proto (package no.jotta.openapi.auth.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { Challenges, Credentials } from "../../credentials_pb.js";
/**
 * @generated from message no.jotta.openapi.auth.v2.Session
 */
export class Session extends Message {
    /**
     * @generated from field: string id = 1;
     */
    id = "";
    /**
     * @generated from field: string ip_address = 2;
     */
    ipAddress = "";
    /**
     * @generated from field: int64 started_at_millis = 3;
     */
    startedAtMillis = protoInt64.zero;
    /**
     * @generated from field: int64 last_accessed_millis = 4;
     */
    lastAccessedMillis = protoInt64.zero;
    /**
     * @generated from field: string device_name = 5;
     */
    deviceName = "";
    /**
     * @generated from field: string client_name = 6;
     */
    clientName = "";
    /**
     * @generated from field: string location = 7;
     */
    location = "";
    /**
     * @generated from field: no.jotta.openapi.auth.v2.Session.SessionType type = 8;
     */
    type = Session_SessionType.UNKNOWN;
    /**
     * country_code is blank when location is unknown or can not be determined
     *
     * @generated from field: string country_code = 9;
     */
    countryCode = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.Session";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "ip_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "started_at_millis", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 4, name: "last_accessed_millis", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 5, name: "device_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 6, name: "client_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 7, name: "location", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 8, name: "type", kind: "enum", T: proto3.getEnumType(Session_SessionType) },
        { no: 9, name: "country_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new Session().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Session().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Session().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Session, a, b);
    }
}
/**
 * @generated from enum no.jotta.openapi.auth.v2.Session.SessionType
 */
export var Session_SessionType;
(function (Session_SessionType) {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    Session_SessionType[Session_SessionType["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * @generated from enum value: WEB = 1;
     */
    Session_SessionType[Session_SessionType["WEB"] = 1] = "WEB";
    /**
     * @generated from enum value: DEVICE = 2;
     */
    Session_SessionType[Session_SessionType["DEVICE"] = 2] = "DEVICE";
})(Session_SessionType || (Session_SessionType = {}));
// Retrieve enum metadata with: proto3.getEnumType(Session_SessionType)
proto3.util.setEnumType(Session_SessionType, "no.jotta.openapi.auth.v2.Session.SessionType", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "WEB" },
    { no: 2, name: "DEVICE" },
]);
/**
 * @generated from message no.jotta.openapi.auth.v2.Event
 */
export class Event extends Message {
    /**
     * @generated from field: no.jotta.openapi.auth.v2.Event.EventType type = 1;
     */
    type = Event_EventType.UNKNOWN;
    /**
     * @generated from field: int64 timestamp = 2;
     */
    timestamp = protoInt64.zero;
    /**
     * @generated from field: string ip_address = 3;
     */
    ipAddress = "";
    /**
     * @generated from field: string location = 4;
     */
    location = "";
    /**
     * @generated from field: string application = 5;
     */
    application = "";
    /**
     * country_code is blank when location is unknown or can not be determined
     *
     * @generated from field: string country_code = 6;
     */
    countryCode = "";
    /**
     * @generated from field: string agent_family = 7;
     */
    agentFamily = "";
    /**
     * @generated from field: string agent_os = 8;
     */
    agentOs = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.Event";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(Event_EventType) },
        { no: 2, name: "timestamp", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 3, name: "ip_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "location", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 5, name: "application", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 6, name: "country_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 7, name: "agent_family", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 8, name: "agent_os", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new Event().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Event().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Event().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Event, a, b);
    }
}
/**
 * @generated from enum no.jotta.openapi.auth.v2.Event.EventType
 */
export var Event_EventType;
(function (Event_EventType) {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    Event_EventType[Event_EventType["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * @generated from enum value: LOGIN = 1;
     */
    Event_EventType[Event_EventType["LOGIN"] = 1] = "LOGIN";
    /**
     * @generated from enum value: LOGIN_ERROR = 2;
     */
    Event_EventType[Event_EventType["LOGIN_ERROR"] = 2] = "LOGIN_ERROR";
    /**
     * @generated from enum value: SEND_RESET_PASSWORD = 3;
     */
    Event_EventType[Event_EventType["SEND_RESET_PASSWORD"] = 3] = "SEND_RESET_PASSWORD";
})(Event_EventType || (Event_EventType = {}));
// Retrieve enum metadata with: proto3.getEnumType(Event_EventType)
proto3.util.setEnumType(Event_EventType, "no.jotta.openapi.auth.v2.Event.EventType", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "LOGIN" },
    { no: 2, name: "LOGIN_ERROR" },
    { no: 3, name: "SEND_RESET_PASSWORD" },
]);
/**
 * @generated from message no.jotta.openapi.auth.v2.LinkedIdentity
 */
export class LinkedIdentity extends Message {
    /**
     * @generated from field: string provider_id = 1;
     */
    providerId = "";
    /**
     * @generated from field: string provider_name = 2;
     */
    providerName = "";
    /**
     * @generated from field: bool linked = 3;
     */
    linked = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.LinkedIdentity";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "provider_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "provider_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "linked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new LinkedIdentity().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkedIdentity().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkedIdentity().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkedIdentity, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.auth.v2.ListSessionsRequest
 */
export class ListSessionsRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.ListSessionsRequest";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new ListSessionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSessionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSessionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSessionsRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.auth.v2.ListSessionsResponse
 */
export class ListSessionsResponse extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.auth.v2.Session sessions = 1;
     */
    sessions = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.ListSessionsResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "sessions", kind: "message", T: Session, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new ListSessionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSessionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSessionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSessionsResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.auth.v2.DeleteSessionRequest
 */
export class DeleteSessionRequest extends Message {
    /**
     * @generated from field: string session_id = 1;
     */
    sessionId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.DeleteSessionRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new DeleteSessionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteSessionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteSessionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteSessionRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.auth.v2.DeleteSessionResponse
 */
export class DeleteSessionResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.DeleteSessionResponse";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new DeleteSessionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteSessionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteSessionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteSessionResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.auth.v2.ListEventsRequest
 */
export class ListEventsRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.ListEventsRequest";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new ListEventsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListEventsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListEventsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListEventsRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.auth.v2.ListEventsResponse
 */
export class ListEventsResponse extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.auth.v2.Event events = 1;
     */
    events = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.ListEventsResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "events", kind: "message", T: Event, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new ListEventsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListEventsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListEventsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListEventsResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.auth.v2.GenerateLoginTokenRequest
 */
export class GenerateLoginTokenRequest extends Message {
    /**
     * @generated from field: no.jotta.openapi.Credentials credentials = 1;
     */
    credentials;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.GenerateLoginTokenRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "credentials", kind: "message", T: Credentials },
    ]);
    static fromBinary(bytes, options) {
        return new GenerateLoginTokenRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateLoginTokenRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateLoginTokenRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateLoginTokenRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.auth.v2.GenerateLoginTokenResponse
 */
export class GenerateLoginTokenResponse extends Message {
    /**
     * @generated from field: no.jotta.openapi.Challenges challenges = 1;
     */
    challenges;
    /**
     * @generated from field: string token = 2;
     */
    token = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.GenerateLoginTokenResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "challenges", kind: "message", T: Challenges },
        { no: 2, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new GenerateLoginTokenResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateLoginTokenResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateLoginTokenResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateLoginTokenResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.auth.v2.ListLinkedIdentitiesRequest
 */
export class ListLinkedIdentitiesRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.ListLinkedIdentitiesRequest";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new ListLinkedIdentitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLinkedIdentitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLinkedIdentitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLinkedIdentitiesRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse
 */
export class ListLinkedIdentitiesResponse extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.auth.v2.LinkedIdentity linked_identities = 1;
     */
    linkedIdentities = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.ListLinkedIdentitiesResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "linked_identities", kind: "message", T: LinkedIdentity, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new ListLinkedIdentitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLinkedIdentitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLinkedIdentitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLinkedIdentitiesResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest
 */
export class InitializeIdentityLinkingRequest extends Message {
    /**
     * @generated from field: string provider_id = 1;
     */
    providerId = "";
    /**
     * the url to return to after linking has been completed
     *
     * @generated from field: string redirect_url = 2;
     */
    redirectUrl = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.InitializeIdentityLinkingRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "provider_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new InitializeIdentityLinkingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InitializeIdentityLinkingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InitializeIdentityLinkingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(InitializeIdentityLinkingRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.auth.v2.InitializeIdentityLinkingResponse
 */
export class InitializeIdentityLinkingResponse extends Message {
    /**
     * an url that when followed will perform the linking
     *
     * @generated from field: string redirect_url = 1;
     */
    redirectUrl = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.InitializeIdentityLinkingResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new InitializeIdentityLinkingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InitializeIdentityLinkingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InitializeIdentityLinkingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(InitializeIdentityLinkingResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.auth.v2.UnlinkIdentityRequest
 */
export class UnlinkIdentityRequest extends Message {
    /**
     * @generated from field: string provider_id = 1;
     */
    providerId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.UnlinkIdentityRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "provider_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new UnlinkIdentityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkIdentityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkIdentityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkIdentityRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.auth.v2.UnlinkIdentityResponse
 */
export class UnlinkIdentityResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.UnlinkIdentityResponse";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new UnlinkIdentityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkIdentityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkIdentityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkIdentityResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.auth.v2.InitializeTFARequest
 */
export class InitializeTFARequest extends Message {
    /**
     * @generated from oneof no.jotta.openapi.auth.v2.InitializeTFARequest.type
     */
    type = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.InitializeTFARequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "totp", kind: "message", T: InitializeTFARequest_InitializeTOTPRequest, oneof: "type" },
        { no: 2, name: "sms", kind: "message", T: InitializeTFARequest_InitializeSMSTFARequest, oneof: "type" },
    ]);
    static fromBinary(bytes, options) {
        return new InitializeTFARequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InitializeTFARequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InitializeTFARequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(InitializeTFARequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest
 */
export class InitializeTFARequest_InitializeTOTPRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeTOTPRequest";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new InitializeTFARequest_InitializeTOTPRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InitializeTFARequest_InitializeTOTPRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InitializeTFARequest_InitializeTOTPRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(InitializeTFARequest_InitializeTOTPRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest
 */
export class InitializeTFARequest_InitializeSMSTFARequest extends Message {
    /**
     * @generated from field: string phone_number = 1;
     */
    phoneNumber = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.InitializeTFARequest.InitializeSMSTFARequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new InitializeTFARequest_InitializeSMSTFARequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InitializeTFARequest_InitializeSMSTFARequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InitializeTFARequest_InitializeSMSTFARequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(InitializeTFARequest_InitializeSMSTFARequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.auth.v2.InitializeTFAResponse
 */
export class InitializeTFAResponse extends Message {
    /**
     * @generated from oneof no.jotta.openapi.auth.v2.InitializeTFAResponse.type
     */
    type = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.InitializeTFAResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "totp", kind: "message", T: InitializeTFAResponse_InitializeTOTPResponse, oneof: "type" },
        { no: 2, name: "sms", kind: "message", T: InitializeTFAResponse_InitializeSMSTFAResponse, oneof: "type" },
    ]);
    static fromBinary(bytes, options) {
        return new InitializeTFAResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InitializeTFAResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InitializeTFAResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(InitializeTFAResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse
 */
export class InitializeTFAResponse_InitializeTOTPResponse extends Message {
    /**
     * @generated from field: string authenticator_uri = 1;
     */
    authenticatorUri = "";
    /**
     * @generated from field: string secret = 2;
     */
    secret = "";
    /**
     * @generated from field: repeated string recovery_codes = 3;
     */
    recoveryCodes = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeTOTPResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "authenticator_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "recovery_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new InitializeTFAResponse_InitializeTOTPResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InitializeTFAResponse_InitializeTOTPResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InitializeTFAResponse_InitializeTOTPResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(InitializeTFAResponse_InitializeTOTPResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse
 */
export class InitializeTFAResponse_InitializeSMSTFAResponse extends Message {
    /**
     * @generated from field: string verification_id = 1;
     */
    verificationId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.InitializeTFAResponse.InitializeSMSTFAResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "verification_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new InitializeTFAResponse_InitializeSMSTFAResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InitializeTFAResponse_InitializeSMSTFAResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InitializeTFAResponse_InitializeSMSTFAResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(InitializeTFAResponse_InitializeSMSTFAResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.auth.v2.ConfirmTFARequest
 */
export class ConfirmTFARequest extends Message {
    /**
     * @generated from oneof no.jotta.openapi.auth.v2.ConfirmTFARequest.type
     */
    type = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.ConfirmTFARequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "totp", kind: "message", T: ConfirmTFARequest_ConfirmTOTPRequest, oneof: "type" },
        { no: 2, name: "sms", kind: "message", T: ConfirmTFARequest_ConfirmSMSTFARequest, oneof: "type" },
    ]);
    static fromBinary(bytes, options) {
        return new ConfirmTFARequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConfirmTFARequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConfirmTFARequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConfirmTFARequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest
 */
export class ConfirmTFARequest_ConfirmTOTPRequest extends Message {
    /**
     * @generated from field: string verification_code = 1;
     */
    verificationCode = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmTOTPRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "verification_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new ConfirmTFARequest_ConfirmTOTPRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConfirmTFARequest_ConfirmTOTPRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConfirmTFARequest_ConfirmTOTPRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConfirmTFARequest_ConfirmTOTPRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest
 */
export class ConfirmTFARequest_ConfirmSMSTFARequest extends Message {
    /**
     * @generated from field: string verification_id = 1;
     */
    verificationId = "";
    /**
     * @generated from field: string verification_code = 2;
     */
    verificationCode = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.ConfirmTFARequest.ConfirmSMSTFARequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "verification_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "verification_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new ConfirmTFARequest_ConfirmSMSTFARequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConfirmTFARequest_ConfirmSMSTFARequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConfirmTFARequest_ConfirmSMSTFARequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConfirmTFARequest_ConfirmSMSTFARequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.auth.v2.ConfirmTFAResponse
 */
export class ConfirmTFAResponse extends Message {
    /**
     * @generated from field: no.jotta.openapi.auth.v2.ConfirmTFAResponse.ConfirmTFAStatus status = 1;
     */
    status = ConfirmTFAResponse_ConfirmTFAStatus.UNKNOWN_TFA_STATUS;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.ConfirmTFAResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ConfirmTFAResponse_ConfirmTFAStatus) },
    ]);
    static fromBinary(bytes, options) {
        return new ConfirmTFAResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConfirmTFAResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConfirmTFAResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConfirmTFAResponse, a, b);
    }
}
/**
 * @generated from enum no.jotta.openapi.auth.v2.ConfirmTFAResponse.ConfirmTFAStatus
 */
export var ConfirmTFAResponse_ConfirmTFAStatus;
(function (ConfirmTFAResponse_ConfirmTFAStatus) {
    /**
     * @generated from enum value: UNKNOWN_TFA_STATUS = 0;
     */
    ConfirmTFAResponse_ConfirmTFAStatus[ConfirmTFAResponse_ConfirmTFAStatus["UNKNOWN_TFA_STATUS"] = 0] = "UNKNOWN_TFA_STATUS";
    /**
     * @generated from enum value: OK = 1;
     */
    ConfirmTFAResponse_ConfirmTFAStatus[ConfirmTFAResponse_ConfirmTFAStatus["OK"] = 1] = "OK";
    /**
     * @generated from enum value: INVALID = 2;
     */
    ConfirmTFAResponse_ConfirmTFAStatus[ConfirmTFAResponse_ConfirmTFAStatus["INVALID"] = 2] = "INVALID";
})(ConfirmTFAResponse_ConfirmTFAStatus || (ConfirmTFAResponse_ConfirmTFAStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(ConfirmTFAResponse_ConfirmTFAStatus)
proto3.util.setEnumType(ConfirmTFAResponse_ConfirmTFAStatus, "no.jotta.openapi.auth.v2.ConfirmTFAResponse.ConfirmTFAStatus", [
    { no: 0, name: "UNKNOWN_TFA_STATUS" },
    { no: 1, name: "OK" },
    { no: 2, name: "INVALID" },
]);
/**
 * @generated from message no.jotta.openapi.auth.v2.DisableTFARequest
 */
export class DisableTFARequest extends Message {
    /**
     * @generated from field: no.jotta.openapi.Credentials credentials = 1;
     */
    credentials;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.DisableTFARequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "credentials", kind: "message", T: Credentials },
    ]);
    static fromBinary(bytes, options) {
        return new DisableTFARequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DisableTFARequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DisableTFARequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DisableTFARequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.auth.v2.DisableTFAResponse
 */
export class DisableTFAResponse extends Message {
    /**
     * @generated from field: no.jotta.openapi.Challenges challenges = 1;
     */
    challenges;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.DisableTFAResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "challenges", kind: "message", T: Challenges },
    ]);
    static fromBinary(bytes, options) {
        return new DisableTFAResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DisableTFAResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DisableTFAResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DisableTFAResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.auth.v2.RegisterSessionRequest
 */
export class RegisterSessionRequest extends Message {
    /**
     * device_name gives this session a name that will be visible in the device list on the account (security) page.
     *
     * @generated from field: string device_name = 1;
     */
    deviceName = "";
    /**
     * Optional user_agent
     *
     * @generated from field: string user_agent = 2;
     */
    userAgent = "";
    /**
     * Optional app_version
     *
     * @generated from field: string app_version = 3;
     */
    appVersion = "";
    /**
     * Optional device_id. the device_id refers to the server id of a backup device.
     * This claims the current session_id as owned by the given device id.
     * Claiming a device id will log out any existing sessions claimed by this device_id,
     * to enforce a single logged in session per backup device.
     *
     * @generated from field: string device_id = 4;
     */
    deviceId = "";
    /**
     * unique identifier for this app
     *
     * @generated from field: string app_id = 5;
     */
    appId = "";
    /**
     * a generic app type, such as 'android', 'desktop-macos' 'desktop-windows', 'linux-cli' or 'ios'
     *
     * @generated from field: string app_type = 6;
     */
    appType = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.RegisterSessionRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "device_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "user_agent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "app_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 5, name: "app_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 6, name: "app_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new RegisterSessionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegisterSessionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegisterSessionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegisterSessionRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.auth.v2.RegisterSessionResponse
 */
export class RegisterSessionResponse extends Message {
    /**
     * session_id echoes back the session id.
     *
     * @generated from field: string session_id = 1;
     */
    sessionId = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.auth.v2.RegisterSessionResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new RegisterSessionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegisterSessionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegisterSessionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegisterSessionResponse, a, b);
    }
}
